export const ExperimentNames = {
    CategoryIdVeloUpdate: 'specs.events.ui.CategoryIdVeloUpdate',
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    StaffPage: 'specs.events.ui.Staff',
    ListLayoutDateStyle: 'specs.events.ui.ListLayoutDateStyle',
    DateAndLocationSettings: 'specs.events.ui.DateLocationSettings',
    TempFixRecurringEvents: 'specs.events.TempFixRecurringEvents',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    ReuseTicketsDesign: 'specs.events.ui.ReuseTicketsDesign',
    DateTimeImprovements: 'specs.events.ui.DateTimeImprovements',
    GuestListTicketTypeFilter: 'specs.events.ui.GuestListTicketTypeFilter',
    TicketDefinitionsLimitReachedWarning: 'specs.events.ui.TicketDefinitionsLimitReachedWarning',
    RemoveUnnecessaryBmRequests: 'specs.events.ui.RemoveUnnecessaryBmRequests',
    CategoriesImprovement: 'specs.events.ui.CategoriesImprovement',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    EnablePromoterDevCenterMigration: 'specs.wosbm.migrate-promote-marketing-tools-to-devcenter',
    SingleEventMobileSizing: 'specs.events.ui.SingleEventMobileSizing',
    UpdatedClassicAddPanel: 'specs.events.ui.UpdatedClassicAddPanel',
    PapyrusPreviewSiteLanguage: 'specs.events.ui.PapyrusPreviewSiteLanguage',
    EventsLimitWarning: 'specs.events.ui.EventsLimitWarning',
    HoppEntryPoint: 'specs.events.ui.HoppEntryPoint',
    LibraryBasedIOD: 'specs.events.ui.LibraryBasedIOD',
    MultidayEventsCalendar: 'specs.events.ui.MultidayEventsCalendar',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    RecurringEventsImprovements: 'specs.events.ui.RecurringEventsImprovements',
    NewReservationsService: 'specs.events.ui.NewReservationsService',
    NewReservationsServiceBM: 'specs.events.ui.NewReservationsServiceBM',
    CheckInBanner: 'specs.events.ui.CheckInBanner',
    DonationInputFix: 'specs.events.ui.DonationInputFix',
    EventPresets: 'specs.events.ui.EventPresets',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations',
    EventsListRedesign: 'specs.events.ui.EventsListRedesign',
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    NewKBArticlesInTicketPreview: 'specs.events.ui.NewKBArticlesInTicketPreview',
    NewTimeZoneList: 'specs.events.ui.NewTimeZoneList',
    GuestInfoDeletedFields: 'specs.events.ui.GuestInfoDeletedFields',
};
//# sourceMappingURL=experiments.js.map